import { Activity } from "lucide-react";

export function RunsListEmptyState() {
  return (
    <div className="p-8 text-center space-y-2">
      <Activity className="w-7 h-7 text-stone-300 dark:text-stone-600 mx-auto" />
      <div className="text-xs font-semibold text-stone-700 dark:text-stone-300">
        No runs recorded
      </div>
      <p className="text-[11px] text-stone-400 dark:text-stone-500">
        Execution runs will appear as conversational turns execute.
      </p>
    </div>
  );
}
